/**
 * 审批工作流 API
 * 后端：36.137.177.118:5000（走主代理，非请假代理）
 * 3 天以内（< 3 天）：班主任单级审批；3 天及以上（>= 3 天）：班主任 + 领导两级审批
 */
import { request } from './request'

/**
 * 发起请假审批流程
 * @param {object} data - { leave_id, selected_leader_id? }
 * @returns {Promise<{ success, message, data: { instance_id, current_approver_id, leave_days, approval_steps } }>}
 */
export function startApproval(data) {
  return request('/api/start-approval', {
    method: 'POST',
    body: JSON.stringify(data)
  })
}

/**
 * 获取审批实例详情
 * @param {number|string} instanceId
 * @returns {Promise<{ success, data: { instance, approval_records } }>}
 */
export function getApprovalInstance(instanceId) {
  return request(`/api/instance/${instanceId}`)
}

/**
 * 根据 leave_id 获取审批实例（含 instance_id）
 * @param {number|string} leaveId
 * @returns {Promise<{ success, data: { instance_id, leave_id, status, ... } }>}
 */
export function getInstanceByLeaveId(leaveId) {
  return request(`/api/instance/leave/${leaveId}`)
}

/**
 * 获取当前用户待审批列表
 * @param {object} params - { page?, page_size? }
 * @returns {Promise<{ success, data: { records, pagination } }>}
 */
export function getPendingApprovals(params = {}) {
  const qs = new URLSearchParams()
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== '') qs.set(k, v)
  })
  const query = qs.toString()
  return request(`/api/pending${query ? '?' + query : ''}`)
}

/**
 * 审批操作（同意/拒绝）
 * @param {number|string} instanceId
 * @param {object} data - { action: 'approve'|'reject', comment? }
 * @returns {Promise<{ success, message, data? }>}
 */
export function approveInstance(instanceId, data) {
  return request(`/api/approve/${instanceId}`, {
    method: 'POST',
    body: JSON.stringify(data)
  })
}

/**
 * 审批请假
 * @param {number|string} leaveId
 * @param {object} data - { approved?, status?, comment?, approval_comment? }
 * @returns {Promise<{ success, message, data?: { leave_id, status } }>}
 */
export function approveLeave(leaveId, data = {}) {
  const normalizedLeaveId = Number(leaveId)
  const approved = typeof data.approved === 'boolean'
    ? data.approved
    : Number(data.status) === 1
      ? true
      : Number(data.status) === 2
        ? false
        : undefined
  const status = Number(data.status) || (approved === true ? 1 : approved === false ? 2 : undefined)
  const comment = data.comment ?? data.approval_comment ?? data.approvalComment ?? ''

  return request('/api/leave/approve', {
    method: 'POST',
    body: JSON.stringify({
      leave_id: Number.isFinite(normalizedLeaveId) ? normalizedLeaveId : leaveId,
      approved,
      status,
      comment,
      approval_comment: comment
    })
  })
}

/**
 * 获取当前用户审批历史
 * @param {object} params - { page?, page_size?, status? } status: pending/approved/rejected
 * @returns {Promise<{ success, data: { records, pagination } }>}
 */
export function getMyApprovalHistory(params = {}) {
  const qs = new URLSearchParams()
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== '') qs.set(k, v)
  })
  const query = qs.toString()
  return request(`/api/my-history${query ? '?' + query : ''}`)
}
